var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k3"},[_c('div',{ref:"fullPage",staticClass:"fullPage"},[_c('div',{ref:"fullPageContainer",staticClass:"fullPageContainer"},[_c('div',{staticClass:"section section1"},[_c('Onepage',{attrs:{"clientPosition":_vm.clientPosition},on:{"showCover":_vm.showCover}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }